import { getViewScope, ViewScope } from "@common/types/views/views";
import { useScope } from "@state/scopeContext.lib";
import { useMemo } from "react";

export function useViewScope(): ViewScope {
    const { workspaceId, organizationId } = useScope();

    return useMemo(
        () =>
            getViewScope({
                workspaceId: workspaceId ?? undefined,
                organizationId: organizationId ?? undefined,
            }),
        [workspaceId, organizationId],
    );
}
